"use strict";
///<reference path="../typings/browser.d.ts" />
var ZIndexManager = (function () {
    function ZIndexManager() {
        this.highest = 10000;
        this.lowest = -10000;
    }
    ZIndexManager.prototype.getHighest = function () {
        return ++this.highest;
    };
    ZIndexManager.prototype.getLowest = function () {
        return --this.lowest;
    };
    return ZIndexManager;
}());
exports.ZIndexManager = ZIndexManager;
function default_1(isSingleton) {
    if (isSingleton === void 0) { isSingleton = true; }
    if (isSingleton) {
        var windowScope = window;
        windowScope.zIndexManagerNamespace = windowScope.zIndexManagerNamespace || {};
        var manager = windowScope.zIndexManagerNamespace.manager;
        if (!manager) {
            windowScope.zIndexManagerNamespace.manager = manager = new ZIndexManager();
        }
        return manager;
    }
    else {
        return new ZIndexManager();
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
;
//# sourceMappingURL=index.js.map